// Import Mirador from node_modules
import Mirador from 'mirador';
import { miradorImageToolsPlugin } from 'mirador-image-tools';
import {
    miradorSharePlugin,
    miradorShareDialogPlugin,
} from 'mirador-share-plugin';

import AnotherCustomMenuItem from './AnotherCustomMenuItem.jsx';
import CustomMenuItem from './CustomMenuItem.jsx';
import CustomMenuComponent from './CustomMenuComponent.jsx';

// Read manifest from the URL.
//
// Example:
// index.html?manifest=https://example.org/manifest.json

const params = new URLSearchParams(window.location.search);
const manifestId = params.get('manifest');

console.log(
    manifestId
        ? `Loading manifest: ${manifestId}`
        : 'Starting Mirador with no manifest'
);

// Only create a window when a manifest was supplied.
const windows = manifestId
    ? [{
        imageToolsEnabled: true,
        imageToolsOpen: true,
        manifestId,
    }]
    : [];

Mirador.viewer({
    id: 'demo',

    // [] means Mirador starts completely empty.
    windows,

    workspace: {
        type: 'mosaic',
    },

    workspaceControlPanel: {
        enabled: true,
    },

    theme: {
        palette: {
            primary: {
                main: '#1967d2',
            },
        },
    },

}, [
    ...miradorImageToolsPlugin,

    {
        ...miradorSharePlugin,
        target: 'CustomMenuComponent',
    },

    miradorShareDialogPlugin,
    AnotherCustomMenuItem,
    CustomMenuItem,
    CustomMenuComponent,
]);